import axios from 'axios';
import { objectToQuery } from 'common/helpers/filters.helper';
import {
  IStockReconciliationShiftCollection,
  IStockReconciliationShiftFilters,
  IStockReconciliationShiftItemsCollection,
  IStockReconciliationShiftItemsFilters,
} from 'entities/StockReconciliation/StockReconciliation.models';

const basePath = '/cir-portal/stock-reconciliation';

export const stockReconciliationTransport = {
  getShiftCollection: (filters: IStockReconciliationShiftFilters): Promise<IStockReconciliationShiftCollection> =>
    axios.get(`${basePath}/shifts${objectToQuery(filters)}`),
  getShiftItemsCollection: ({
    shiftKey,
    ...filters
  }: IStockReconciliationShiftItemsFilters): Promise<IStockReconciliationShiftItemsCollection> =>
    axios.get(`${basePath}/shifts/${encodeURIComponent(shiftKey)}/items${objectToQuery(filters)}`),
};
